import { useState, useEffect, Fragment } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./style.css";
import { useAuthContext } from "../../hooks";
import { getOrgUserDetails } from "../../api/users/getOrgUserDetails";
import { useForm } from "react-hook-form";
import { applyLeave } from "../../api/LeaveManagement/applyLeave";
import { getAllLeaveType } from "../../api/LeaveManagement/getLeaveType";
import { getOrgUserLeaveHistory } from "../../api/LeaveManagement/getOrgUserLeaveHistory";
import deleteOrgUserLeave from "../../api/LeaveManagement/Delete/deleteOrgUserLeav";
import { getProjectLeadEmail } from "../../api/ProjectLeadPerformance/getProjectLeadEmail";
import LeaveManagementSc from "./index.sc";
import { apply_emergency_pto } from "../../api/EmergencyPTO/applyepto";
import { getReportsToEmail } from "../../api/EmergencyPTO/get_reports_to_email";
// import { apply_emergency_pto } from "../../api/EmergencyPTO";
import EmergencyPto from "./Modal/index";
import { useNavigate } from "react-router-dom";
import { getUserEPto } from "../../api/EmergencyPTO/getAllEPtobyUser";
import calculateEmergencyPto from "./hooks/leave";
import PTO from "./PTO/index";
import { getOrgUserPtoMasterData } from "../../api/LeaveManagement/getUserMasterPto";
import calculateWorkFromHome from "./hooks/workfromhome";
import { toast } from "react-toastify";
import { sendEmail } from "../../api/MailSender/mailSender";
import { leaveTemplate } from "../../Templates/leaveTemplate";
import { AuthContextProps } from "../../Context/AuthContext/type";
import { WFHTemplate } from "../../Templates/WFHTemplate";

function Leave() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  const [deleteData, setDeleteData] = useState<any>([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const todayDate = new Date().toISOString().split("T")[0];
  console.log("??", todayDate)

  console.log(new Date(deleteData.start_date) < new Date(todayDate) ? true : false);

  console.log("Start Date:", new Date(deleteData.start_date));
  console.log("Today Date:", new Date(todayDate));
  console.log("Comparison Result:", new Date(deleteData.start_date) > new Date(todayDate));


  function handleShow1(data: any) {
    setShow1(true);
    console.log("____wqwq", data)
    setDeleteData(data);
    console.log("______sqhhjsahgd", deleteData)
  }
  const auth = useAuthContext();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [user, setUser] = useState<any>([]);
  const fetchOrgUser = async () => {
    setUser(
      await getOrgUserDetails(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
  };
  const [leaveType, setLeaveType] = useState<any>([]);
  const fetchLeaveType = async () => {
    setLeaveType(await getAllLeaveType(auth?.userInfo?.orgs[0]?.id));
  };
  const [leaveHistory, setLeaveHistory] = useState<any>([]);
  const fetchOrgUserLeaveHistory = async () => {
    setLeaveHistory(
      await getOrgUserLeaveHistory(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
  };
  const [tlEmail, setTlEmail] = useState<any>([]);
  const fetchOrgUserProjectlead = async () => {
    setTlEmail(
      await getProjectLeadEmail(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
  };
  const [repEmail, setRepEmail] = useState<any>([]);
  const getReportsToEmailFun = async () => {
    setRepEmail(
      await getReportsToEmail(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
  };

  useEffect(() => {
    fetchOrgUser();
    fetchLeaveType();
    fetchOrgUserLeaveHistory();
    fetchOrgUserProjectlead();
    getReportsToEmailFun();
  }, [repEmail?.[0]?.reports_to_id]);

  const receiverEmails: any[] = [];
  tlEmail?.map((data: any) => {
    return receiverEmails.push(data?.tl_email);
  });

  const [leaveid, setLeaveId] = useState<{ id: any }[]>([]);
  const handleClickFunc = (data: any) => {
    // console.log(data,"hanlde click")
    const newMemberNames = [...leaveid, data?.id, data?.leave_type_id];
    setLeaveId(newMemberNames);
  };
  // console.log(leaveid,"hanlde click")
  const deleteFunction = async () => {
    const res = await deleteOrgUserLeave(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
      leaveid?.[0],
      leaveid[1]
    );
    console.log(res, "from delete fucnion");
    await fetchOrgUserLeaveHistory();
    handleClose1();
    await fetchOrgUserLeaveHistory();
    if (res.message === "success") {
      alert("Leave Deleted successfully");
      console.log("______122_", receiverEmails)
      const DeleteReceiverEmails = [...receiverEmails, "mukilam@xbi4.com"]
      const emailTemplate = leaveTemplate(auth, deleteData, "Cancelled")
      await sendEmail("workforce@insytix.com", DeleteReceiverEmails, emailTemplate, `Leave Cancellation`);
    } else {

      toast.error("Error in deleting leave");
    }
    setLeaveId([]);
  };

  const handleCreate = async (e: any) => {
    try {
      console.debug("data > ", e);
      const res = await applyLeave(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        {
          ...e,
          first_name: `${auth?.userInfo?.first_name} ${auth?.userInfo?.last_name}`,
          email: receiverEmails?.join(","),
        }
      );

      console.log("Leave apply response:", res);
      toast.success("Leave applied successfully");

      // const DeleteReceiverEmails = [...receiverEmails, "mukilam@xbi4.com"];
      // const emailTemplate = WFHTemplate(auth, deleteData);

      // console.log("Sending email to:", DeleteReceiverEmails);

      // const emailResponse = await sendEmail("workforce@insytix.com", DeleteReceiverEmails, emailTemplate, `Leave Applied`);

      // console.log("sendEmail response:", emailResponse);

    } catch (err) {
      console.error("Error in applying leave:", err);
      toast.error("Error in applying leave");
    }
  };

  // const handleCreate = async (e: any) => {
  //   console.log("CREATE")
  //   try {
  //     console.debug("handleCreate triggered with data:", e);



  //     const res = await applyLeave(
  //       auth?.userInfo?.orgs[0]?.id,
  //       (auth?.userInfo?.orgs_user_id[0]).toString(),
  //       {
  //         ...e,
  //         first_name: `${auth?.userInfo?.first_name} ${auth?.userInfo?.last_name}`,
  //         email: receiverEmails?.join(","),
  //       }
  //     );


  //     console.log("API Response from applyLeave:", res);

  //     if (!res || !res.message || res.message !== "success") {
  //       console.error("Error: applyLeave failed", res);
  //       toast.error("Error applying leave. Please try again.");
  //       return;
  //     }

  //     toast.success("Leave applied successfully");

  //     // Prepare email
  //     const emailTemplate = WFHTemplate(auth, e);
  //     console.log("Generated email template:", emailTemplate);

  //     // Define recipients
  //     const DeleteReceiverEmails = [...receiverEmails, "mukilam@xbi4.com"];
  //     console.log("Sending email to:", DeleteReceiverEmails);

  //     // Send email and await confirmation
  //     const emailResponse = await sendEmail(
  //       "workforce@insytix.com",
  //       DeleteReceiverEmails,
  //       emailTemplate,
  //       `Leave Applied`
  //     );

  //     console.log("sendEmail response:", emailResponse);
  //   } catch (err) {
  //     console.error("Error in applying leave:", err);
  //     toast.error("Error in applying leave.");
  //   }
  // };


  const onSubmit = async (e: any) => {
    await handleCreate(e);
    reset();
    await fetchOrgUserLeaveHistory();
    setShow(false);
    await fetchOrgUserLeaveHistory();
  };
  useEffect(() => {
    // Check if the "reason" field has at least 50 characters
    if (watch("reason")?.length >= 50) {
      setIsSubmitDisabled(false); // Enable the submit button
    } else {
      setIsSubmitDisabled(true); // Disable the submit button
    }
  }, [watch("reason")]);
  const [ePtos, setEPtos] = useState([]);
  const fetchUserEPto = async () => {
    try {
      const data = await getUserEPto(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      );
      setEPtos(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserEPto();
  }, []);
  const [masterData, setMasterData] = useState<any>([]);
  const fetchAllUsersMasterPTO = async () => {
    await getOrgUserPtoMasterData(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString()
    )
      .then((e) => {
        setMasterData(e);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchOrgUserLeaveHistory();
    fetchAllUsersMasterPTO();
  }, [leaveHistory?.[0]?.data]);
  const [isDisabled, setIsDisabled] = useState(false);
  const buttonDisabled = leaveHistory?.[0]?.available_off;
  // console.log('button disabled', buttonDisabled)
  const currentDate = new Date();
  const tenDaysLater = new Date(currentDate);
  tenDaysLater.setDate(currentDate.getDate() + 10);

  // console.log(masterData, 'emergency ptos are here please seee')

  const isEmergencyPtoAvailable =
    masterData?.[0]?.total_emergency_pto_leaves >= 2;
  const emergencyCount: {} = calculateEmergencyPto(ePtos);
  const enoughWFH: any = calculateWorkFromHome(leaveHistory);
  // console.log(user,"emergency pto see here")
  const notify = () => {
    toast.success("This is a success notification");
    // You can also use other types like toast.error, toast.warning, etc.
  };
  return (
    <LeaveManagementSc>
      <div className="App">
        <h1>TIME-OFF MANAGEMENT</h1>
      </div>
      <div className="apply-button">
        <Button
          variant="primary"
          onClick={() => handleShow()}
          className="leave-button"
        // style={{ width: "150px", height: "20px", display: "flex", jus }}
        >
          + Apply WFH
        </Button>
        <EmergencyPto
          ReportsTo={repEmail}
          buttonDisabled={isEmergencyPtoAvailable}
          refershEPto={fetchUserEPto}
          isAvailable={emergencyCount}
          orgUserPtoRef={fetchOrgUserLeaveHistory}
        />
        <PTO fetchPto={fetchUserEPto} orgUserPto={fetchOrgUserLeaveHistory} />
      </div>
      <div className="leave-main">
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Leave Applicationss</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {user?.map((data: any, idx: any) => {
              return (
                <Fragment key={idx}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Employee Name: </Form.Label>
                      <Form.Control
                        type="text"
                        value={data?.first_name + " " + data?.last_name}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Desigation</Form.Label>
                      <Form.Control type="text" value={data?.role} disabled />
                    </Form.Group>
                    <Form.Label>Type of Leave</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      {...register("leave_type", {})}
                    >
                      <option value="">Select Leave Type</option>
                      {/* {leaveType?.map((data: any) => {
                        if (
                          data?.leave_type !== 'Emergency-PTO' &&
                          data?.leave_type !== 'PTO' && data.leave_type !== 'COMP OFF'
                        
                        ) {
                          return (
                            <option key={data?.id} value={data?.id}>
                              {data?.leave_type}
                            </option>
                          )
                        }
                        return null
                      })} */}
                      <option value="3">Floating Holiday</option>
                      {enoughWFH?.workfromhome >= 6 ? (
                        <option disabled>You have taken all your WFH</option>
                      ) : (
                        <option value="4">Work From Home</option>
                      )}
                      <option value="6">Loss of Pay</option>
                    </Form.Select>
                    {/* {errors.leave_type?.message && (
                      <p>{errors.leave_type?.message}</p>
                    )} */}
                    <br></br>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label className="date">From:</Form.Label>
                      <input
                        type="date"
                        className="date1"
                        aria-label="from-dtae"
                        {...register("start_date")}
                      />

                      <Form.Label className="date">To :</Form.Label>
                      <input
                        type="date"
                        aria-label="from-dtae"
                        className="date1"
                        {...register("end_date")}
                      />
                    </Form.Group>

                    <Form.Select
                      aria-label="Default select example"
                      {...register("leave_duration")}
                    >
                      <option value="">Select duration</option>

                      <option value="0.125">1 Hour</option>
                      <option value="0.25">2 Hours</option>
                      <option value="0.375">3 Hours</option>
                      <option value="0.5">4 Hours</option>
                      <option value="0.625">5 Hours</option>
                      <option value="0.75">6 Hours</option>
                      <option value="0.875">7 Hours</option>
                      <option value="1">8 Hours</option>
                    </Form.Select>

                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label>Reason</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Example: PTO , WFH , Floating Holiday"
                        {...register("reason")}
                      />
                    </Form.Group>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit(onSubmit)}
                      disabled={isSubmitDisabled}
                    >
                      Apply Leave
                    </Button>
                  </form>
                </Fragment>
              );
            })}
          </Modal.Body>
        </Modal>
        {/* modal emergency pto */}

        <div className="leave-approval-card">
          <div className="leave-details-container-user">
            {leaveHistory &&
              leaveHistory?.map((data: any, idx: any) => {
                return (
                  <Fragment key={idx}>
                    <div className="total-leave-conatiner">
                      <p> Total Off</p>
                      <p>{data?.total_off}</p>
                    </div>
                    <div className="consumed-leave-container">
                      <p>Consumed Off</p>

                      <div>{data?.consumed_off}</div>
                    </div>
                    <div className="available-leave-container">
                      <p>Available Off</p>
                      <div>{data?.available_off}</div>
                    </div>
                  </Fragment>
                );
              })}
          </div>
        </div>
        <div>
          <table>
            <tr>
              <th className="heading">Applied Date</th>
              <th className="heading">From Date</th>
              <th className="heading">To Date</th>
              <th className="heading">Type OF Leave</th>
              <th className="heading">Duration</th>
              <th className="heading">Reason</th>
            </tr>
            {leaveHistory &&
              leaveHistory.map((data: any) => {
                return (
                  <>
                    {data?.history?.map((data: any, ix: any) => {
                      return (
                        <Fragment key={ix}>
                          <tr
                            onClick={() => {
                              handleClickFunc(data);
                              handleShow1(data);
                            }}
                          >
                            <td>{data?.applied_on}</td>
                            <td>{data?.start_date}</td>
                            <td>{data?.end}</td>
                            <td>{data?.leave_type_name}</td>
                            <td>
                              {data?.duration < 1 ? (
                                <>{data?.duration} hours</>
                              ) : data?.duration === 1 ? (
                                <>1 day</>
                              ) : (
                                <>{data?.duration} days</>
                              )}
                            </td>
                            <td>{data?.reason}</td>
                          </tr>
                        </Fragment>
                      );
                    })}
                  </>
                );
              })}
          </table>
        </div>
      </div>
      <label>Emergency PTO</label>
      <table>
        <thead>
          <tr>
            <th className="heading">Start date</th>
            <th className="heading">End date</th>
            <th className="heading">Duration</th>
            <th className="heading">Leave type</th>
            <th className="heading">Reason</th>
            <th className="heading">Status</th>
          </tr>
        </thead>

        <tbody>
          {ePtos?.map((data: any) => (
            <tr key={data.id}>
              <td>{data?.start_date}</td>
              <td>{data?.end_date}</td>
              <td>
                {data?.duration < 1 ? (
                  <>{data?.duration} hours</>
                ) : data?.duration === 1 ? (
                  <>1 day</>
                ) : (
                  <>{data?.duration} days</>
                )}
              </td>
              <td>
                {data?.leave_type_id === 2 ? "Emergency PTO" : "Comp Off"}
              </td>
              <td>{data?.reason}</td>
              <td>
                {data?.status === "approve" || data?.status === "decline" ? (
                  <>{data?.status}d</>
                ) : (
                  <>No response</>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal show={show1} onHide={handleClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Leave</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {new Date(deleteData.start_date) < new Date(todayDate) ? (
            <p style={{ color: "red" }}>
              Unable to delete the leave because it exceeds the applied date
            </p>
          ) : (
            <>
              <p>Delete leave Will Delete Completely</p>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose1}>
                  No
                </Button>
                <Button variant="danger" onClick={deleteFunction}>
                  Delete
                </Button>
              </Modal.Footer>
            </>
          )}

        </Modal.Body>
      </Modal>
    </LeaveManagementSc >
  );
}

export default Leave;
